import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useV2ProductRegulationSection } from './context'
import { RegulationEmptyPanel } from './RegulationEmptyPanel'
import { getRegulationEmptyStateKey, regulationIsOn } from './utils'

export function V2ProductRegulationSectionUndecidedEmpty() {
  const {
    applicability,
    isLoading,
    questionnaireEditDisabled,
    openDetermineSheet,
  } = useV2ProductRegulationSection()
  const { t } = useTranslation('common')
  const status = applicability?.status

  if (
    isLoading ||
    regulationIsOn(applicability) ||
    status === 'NEEDS_GRILLING' ||
    status === 'NOT_APPLICABLE'
  ) {
    return null
  }

  const emptyStateKey = getRegulationEmptyStateKey(applicability)

  return (
    <RegulationEmptyPanel
      title={t(
        `v2.pages.products.detail.regulationSection.empty.${emptyStateKey}.title`
      )}
      description={t(
        `v2.pages.products.detail.regulationSection.empty.${emptyStateKey}.description`
      )}
      action={
        <Button
          type='button'
          size='sm'
          disabled={questionnaireEditDisabled}
          onClick={openDetermineSheet}
        >
          {t(
            'v2.pages.products.detail.regulationSection.empty.determineApplicability'
          )}
        </Button>
      }
    />
  )
}
